import React, { useState, useEffect } from "react";
import Delivery from "../img/delivery.png";
import HeroBg from "../img/heroBg.png";
//import { heroData } from "../utils/data";
import { useStateValue } from "../context/StateProvider";
import { getAllItems } from "../utils/firebaseFunctions";
import { actionType } from "../context/reducer";

const HomeContainer = () => {
  const mobileNumber = "+591 69475247"; //Nayra
  const message = "Quisiera que me informe mas acerca de los servicios de 🅂🄰🄱🄾🅁 🄳🅄🄻🄲🄴 & 🄵🄸🄴🅂🅃🄰."
  const [numberEmptyError, setNumberEmptyError] = useState(false);  
  const [messageEmptyError, setMessageEmptyError] = useState(false);  
  const [{ items }, dispatch] = useStateValue();

  const fetchData = async () => {
    await getAllItems().then((data) => {
      dispatch({
        type: actionType.SET_ITEMS,
        items: data,
      });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const useCheckMobileScreen = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const handleWindowSizeChange = () => {
            setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    return (width <= 768);
  }

  const Saludar = ()  => {
     var currentTime = new Date();
     currentTime.getHours();
     var currentHour = currentTime.getHours();
     var result = "";
     switch (true) {
      case (currentHour < 12):
          result = "*Buenos dias!*%0a%0a";
          break;
      case (currentHour > 12 && currentHour < 17):
          result = "*Buenas tardes!*%0a%0a";
          break;
      default:
          result = "*Buenas noches!*%0a%0a"; 
          break;
      }
      console.log(result);
      return result;
  }

  const onSubmit = (e) => {
    e.preventDefault();
    if (mobileNumber.length < 1) {
      setNumberEmptyError(true);
      setTimeout(() => setNumberEmptyError(false), 3000);
    } else if (message.length < 1) {
      setMessageEmptyError(true);
      setTimeout(() => setMessageEmptyError(false), 3000);
    } else {
      // Regex expression to remove all characters which are NOT alphanumeric
      let number = mobileNumber.replace(/[^\w\s]/gi, "").replace(/ /g, "");
  
      // Appending the phone number to the URL
      let url = "";
      if(!useCheckMobileScreen)
      {
         url = `https://web.whatsapp.com/send?phone=${number}`;
        // Appending the message to the URL by encoding it
        url += `&text=${encodeURI(Saludar() + message)}&app_absent=0`;
      }
      else
      {
        url = `https://wa.me/${number}/?text=${Saludar() + message}`;  //url = `https://wa.me/${number}/?text=urlencodedtextjimmy`;
      }

      // Open our newly created URL in a new tab to send the message
      window.open(url);
    }
  };

    return (
      <section
        className="grid grid-cols-1 md:grid-cols-2 gap-2 w-full "
        id="home"
      >
        <div className="py-2 flex-1 flex flex-col items-start justify-center gap-6">
          {/* <marquee className="text-red-600">.</marquee> */}
          <div className="flex items-center gap-2 justify-center bg-orange-100 px-4 py-1 rounded-full">
            <p className="text-base text-orange-500 font-semibold">
              Servicio de Delivery
            </p>
            <div className="w-8 h-8 bg-white rounded-full overflow-hidden drop-shadow-xl">
              <img
                src={Delivery}
                className="w-full h-full object-contain"
                alt="delivery"
              />
            </div>
          </div>
  
          <p className="text-[1.5rem] lg:text-[4.0rem] font-bold tracking-wide text-headingColor">
            Sabor Dulce & Fiesta
            <div className="flex space-x-1 mb-1 text-slate-400 font-normal">
            <span className="text-orange-600 text-[2rem] text-xs-[2rem]">
              Eventos Creativos
            </span>
            </div>
          </p>
    
          <p className="text-base text-textColor text-center md:text-left md:w-[80%]">
           Tenemos todo lo necesario para hacer de su evento un exito, acompañamos nuestra pasteleria exclusiva con chocolateria, fuente fondue, decoracion y catering.
          </p>
  
          <button
            type="button"
            onClick={onSubmit}
            className="bg-gradient-to-br from-orange-400 to-orange-500 w-full md:w-auto px-4 py-2  rounded-lg hover:shadow-lg transition-all ease-in-out duration-100"
          >
            Ordenar  Ya
          </button>
        </div>
        <div className="py-2 flex-1 flex items-center relative">
          <img
            src={HeroBg}
            className=" ml-auto h-420 w-full lg:w-150% lg:h-650"
            alt="hero-bg"
          />
  
          <div className="w-full h-full absolute top-4 left-0 flex items-center justify-center lg:px-58  py-16 gap-10 flex-wrap">
            {items &&
              items.filter(opt => opt.isShowcaseProduct).map((n) => (
                <div
                  key={n.title}
                  className="  lg:w-190  p-4 bg-cardOverlay backdrop-blur-md rounded-3xl flex flex-col items-center justify-center drop-shadow-lg"
                >
                  <img
                    src={n.imageURL}
                    className="w-20 lg:w-40 -mt-10 lg:-mt-20 "
                    alt="I1"
                  />
                  <p className="text-base lg:text-xl font-semibold text-textColor mt-2 lg:mt-4">
                    {n.title}
                  </p>
  
                  <p className="text-[12px] lg:text-sm text-lighttextGray font-semibold my-1 lg:my-3">
                    {n.description}
                  </p>
  
                  <p className="text-sm font-semibold text-headingColor">
                    <span className="text-xs text-red-600">bs </span> {n.price}
                  </p>
                </div>
              ))}
          </div>
        </div>
      </section>
    );
  };
  
  export default HomeContainer;